export const lineSeriesDropdownItems = [
    {
        id: 'closePrice',
        label: 'Stängningskurs',
    },
    {
        id: 'vwap',
        label: 'VWAP',
    },
    {
        id: 'marketcap',
        label: 'Börsvärde',
    },
    {
        id: 'numberOfShares',
        label: 'Antal aktier',
    },
] as const

export const graphLineSerieRoutingParam = 'lineSerie' as const

export const barSeriesDropdownItems = [
    {
        id: 'splitAdjustedQuantity',
        label: 'Antal aktier',
    },
    {
        id: 'turnoverSek',
        label: 'Omsättning i SEK',
    },
    {
        id: 'tradedProportion',
        label: 'Omsatta aktier / Totalt antal',
    },
] as const

export const graphBarSerieRoutingParam = 'barSerie' as const
